export interface IContactFormModel {
    type: string
    value: string
}

export const contactInitValues: IContactFormModel = {
    type: "",
    value: ""
}